<template>
  <div class="AppDrawer" data-aos="slide-right" data-aos-duration="500">
    <div class="AppDrawer_close">
      <CloseButton @click="closeDrawer"></CloseButton>
    </div>
    <span class="AppDrawer_label" data-aos="fade-right" data-aos-delay="150">
      {{ label }}
    </span>
    <h2 class="AppDrawer_title" data-aos="fade-right" data-aos-delay="300">
      {{ title }}
    </h2>
    <span
      class="AppDrawer_subtitle"
      data-aos="fade-right"
      data-aos-delay="450"
      >{{ subtitle }}</span
    >

    <div class="AppDrawer_content" data-aos="fade" data-aos-delay="600">
      <slot name="content"></slot>
    </div>

    <div @click="goToContacts" class="AppDrawer_message">
      We're here to help — 24 hours a day, 365 days a year!
    </div>
  </div>
</template>

<script>
import CloseButton from "@/components/CloseButton.vue";

export default {
  name: "AppDrawer",

  components: { CloseButton },

  props: {
    label: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  },

  methods: {
    closeDrawer() {
      this.$emit("close-drawer");
    },

    goToContacts() {
      this.$emit("open-contacts");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/function.scss";
@import "@/assets/breackpoints.scss";

.AppDrawer {
  position: fixed;
  top: 0;
  left: 0;
  width: 50%;
  height: 100vh;
  color: #ffffff;
  box-sizing: border-box;
  /* overflow: auto; */
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: vw(135px) vw(120px) 0 vw(120px);
  background-color: rgba(#01432b, 0.75);
  z-index: 10;

  @media (max-width: $xxxl) {
    padding: vw(105px) vw(100px) 0 vw(100px);
  }

  @media (max-width: $xxl) {
    padding: vw(105px) vw(50px) 0 vw(50px);
    max-width: 992px;
    width: 100%;
  }

  @media (max-width: $lg) {
    max-width: 100%;
    width: 100%;
  }

  @media (max-width: $md) {
    padding: 100px 15px 170px 15px;
  }

  @media (max-width: $sm) {
    background-color: rgba(#01432b, 0.95);
  }

  &_label {
    font-size: 24px;
    letter-spacing: vw(4px);
    text-transform: uppercase;

    @media (max-width: $sm) {
      font-size: 18px;
    }
  }

  &_title {
    margin: 0;
    display: block;
    font-weight: 800;
    font-size: 34px;
    letter-spacing: vw(6px);
    text-transform: uppercase;

    @media (max-width: $sm) {
      font-size: 20px;
    }
  }

  &_subtitle {
    font-size: 13px;
    // text-transform: uppercase;
    letter-spacing: 0;

    @media (max-width: $sm) {
      font-size: 10px;
    }
  }

  &_content {
    margin-top: vw(50px);
    padding-bottom: vw(80px);

    h3 {
      margin-top: vw(60px);
      margin-bottom: vw(50px);
      font-size: 34px;
      letter-spacing: vw(6px);
      text-transform: uppercase;

      @media (max-width: $sm) {
        font-size: 20px;
      }
    }

    p,
    li {
      text-align: justify;
    }

    p {
      margin: 5px 0;
    }

    > div > img {
      margin-top: 30px;
    }

    .flex-row {
      margin-top: 30px;
      display: flex;
      align-items: flex-start;

      @media (max-width: $md) {
        flex-direction: column;
        align-items: center;
      }

      p {
        max-width: 100%;
      }

      img {
        margin-right: 30px;

        @media (max-width: $md) {
          margin-right: 0;
        }
      }
    }

    .flex-collumn {
      display: flex;
      flex-direction: column;
    }
  }

  &_close {
    position: absolute;
    top: vw(45px);
    right: vw(45px);
  }

  &_message {
    text-align: center;
    padding-bottom: 50px;
    transition: color 0.3s ease;

    &:hover {
      color: rgba(#ffffff, 0.7);
      cursor: pointer;
    }
  }
}
</style>
